import { setVariantsVisualizationMetric as setVariantsVisualizationMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    metric?: Number,
}

export const setVariantsVisualizationMetric = ({
    metric,
    eventEmitter,
}: Props) => {
    setVariantsVisualizationMetricDiagram(metric);
};
